import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { WorkOrder, WorkOrderOverview } from '../work-order'
import { WorkOrderService } from '../work-order.service'
import {
  ElderQuantityInputControlComponent,
  ElderToastService,
  ElderValidationErrorDirective,
  Unit,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-work-order-header',
  templateUrl: './work-order-header.component.html',
  styleUrls: ['./work-order-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    ElderValidationErrorDirective,
    ElderQuantityInputControlComponent,
    FormsModule,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class WorkOrderHeaderComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly workOrder$ = new BehaviorSubject<WorkOrder>(null)
  public readonly overview$ = new BehaviorSubject<WorkOrderOverview>(null)
  public Unit = Unit
  private workOrderService = inject(WorkOrderService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    if (this.workOrder$.getValue() && !this.overview$.getValue()) {
      this.loadOverview(this.workOrder$.getValue().id)
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set workOrder(workOrder: WorkOrder) {
    this.workOrder$.next(workOrder)
  }

  @Input()
  public set overview(overview: WorkOrderOverview) {
    this.overview$.next(overview)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private loadOverview(workOrderId: string): void {
    this.workOrderService.getOverview(workOrderId).subscribe({
      next: (overview) => this.overview$.next(overview),
      error: (err) => this.toastService.error('Failed to load WorkOrderOverview!', err),
    })
  }
}
